import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "1400"
    },
    on: {
      "close": _vm.closeDialog
    }
  }, [[_c(VStepper, {
    attrs: {
      "color": _vm.color,
      "non-linear": ""
    },
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c(VStepperHeader, [_c(VStepperStep, {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1",
      "color": _vm.color,
      "editable": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.define')) + "\n        ")]), _c(VDivider), _c(VStepperStep, {
    attrs: {
      "editable": Boolean(_vm.selectedBridge && _vm.parentId),
      "complete": _vm.step > 2,
      "step": "2",
      "color": _vm.color
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.upload')) + "\n        ")]), _c(VDivider), _c(VStepperStep, {
    attrs: {
      "step": "3",
      "color": _vm.color,
      "editable": Boolean(_vm.hasCsvUploaded && _vm.validationErrors.length === 0)
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.confirm')) + "\n        ")])], 1), _c(VStepperItems, [_c(VStepperContent, {
    attrs: {
      "step": "1"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    model: {
      value: _vm.selectedAccount,
      callback: function ($$v) {
        _vm.selectedAccount = $$v;
      },
      expression: "selectedAccount"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VSwitch, {
    staticClass: "pl-4 pr-4",
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.useTemplate'),
      "inset": "",
      "color": _vm.color
    },
    model: {
      value: _vm.useTemplate,
      callback: function ($$v) {
        _vm.useTemplate = $$v;
      },
      expression: "useTemplate"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_vm.useTemplate ? [_c(VAutocomplete, {
    attrs: {
      "data-cy": "select_Template",
      "disabled": _vm.accountTemplatesData.templates.length === 0,
      "loading": _vm.accountTemplatesData.isLoading,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.template'),
      "items": _vm.accountTemplatesData.templates,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "title",
      "item-value": "id",
      "hide-details": "",
      "disable-lookup": "",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.title) + " (ID " + _vm._s(data.item.id) + ")")]), _c(VListItemSubtitle)], 1)];
      }
    }, {
      key: "append-item",
      fn: function () {
        return [_c('div', {
          directives: [{
            def: Intersect,
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.endTemplatesIntersect,
            expression: "endTemplatesIntersect"
          }]
        })];
      },
      proxy: true
    }], null, false, 512522208),
    model: {
      value: _vm.selectedTemplate,
      callback: function ($$v) {
        _vm.selectedTemplate = $$v;
      },
      expression: "selectedTemplate"
    }
  }), _vm.accountTemplatesData.templates.length > 0 ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.selectTemplate')) + "\n                ")]) : _vm._e(), _vm.selectedAccount && _vm.accountTemplatesData.templates.length === 0 ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noTemplateText')) + "\n                  "), _c('br'), _c('router-link', {
    attrs: {
      "to": "/device-templates"
    }
  }, [_c('span', {
    class: `${_vm.color}--text`
  }, [_vm._v("\n                      » " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noTemplateLink')) + "\n                    ")])])], 1) : _vm._e()] : [_c(VSelect, {
    attrs: {
      "disabled": _vm.deviceBridgesForAccount.length === 0,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.types'),
      "items": _vm.deviceBridgesForAccount,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [_vm.bridgeTypesIcons[data.item.type] ? _c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[data.item.type],
            "alt": data.item.name,
            "title": data.item.name
          }
        }) : _vm._e()])], 1), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _c(VListItemSubtitle, [_vm._v("\n                        " + _vm._s(data.item.type.replace('bridge-', '')) + " (ID " + _vm._s(data.item.id) + ")\n                      ")])], 1)];
      }
    }]),
    model: {
      value: _vm.selectedBridge,
      callback: function ($$v) {
        _vm.selectedBridge = $$v;
      },
      expression: "selectedBridge"
    }
  }), !_vm.deviceBridgesLoading && _vm.selectedAccount && _vm.deviceBridgesForAccount.length === 0 ? _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noConnectorText')) + "\n                  "), _c('br'), _c('router-link', {
    attrs: {
      "to": "/connectors/list"
    }
  }, [_c('span', {
    class: `${_vm.color}--text`
  }, [_vm._v("\n                      » " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.wizard.noConnectorLink')) + "\n                    ")])])], 1) : _vm._e()]], 2), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_vm.useTemplate && _vm.parentDTwin.id ? _c(VTextField, {
    attrs: {
      "data-cy": "device_parent_id",
      "value": `${_vm.parentDTwin.title} (ID:${_vm.parentDTwin.id})`,
      "disabled": "",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel')
    }
  }) : _c('core-dtwin-finder', {
    attrs: {
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.selectedAccount,
      "objectFilter": _vm.parentSelectorFilter,
      "disabled": !_vm.selectedBridge,
      "loadFullDtwinData": false,
      "sameTenant": "",
      "required": "",
      "hideDetails": ""
    },
    model: {
      value: _vm.parentId,
      callback: function ($$v) {
        _vm.parentId = $$v;
      },
      expression: "parentId"
    }
  })], 1), _vm.selectedBridge ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTooltip, {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c(VAutocomplete, {
          attrs: {
            "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.selectColumns'),
            "items": _vm.availableCreationFields,
            "item-text": "name",
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "hide-details": "",
            "multiple": "",
            "return-object": "",
            "small-chips": ""
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function (data) {
              return [_c(VListItemAction, [_c(VCheckbox, {
                staticStyle: {
                  "display": "inline-block"
                },
                attrs: {
                  "value": _vm.selectedCreationFields.includes(cf => cf.field === data.item.field)
                }
              })], 1), _c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                            " + _vm._s(data.item.name) + "\n                            "), _vm.useTemplate && data.item.usedInTemplate ? [_vm._v("\n                               \n                              "), _c(VIcon, {
                attrs: {
                  "size": "small"
                }
              }, [_vm._v("fa-sitemap")])] : _vm._e()], 2)], 1)];
            }
          }], null, true),
          model: {
            value: _vm.selectedCreationFields,
            callback: function ($$v) {
              _vm.selectedCreationFields = $$v;
            },
            expression: "selectedCreationFields"
          }
        })], 1)];
      }
    }], null, false, 264249249)
  }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.selectFields')))])])], 1) : _vm._e()], 1), _c(VRow, [_vm.selectedBridge ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-0",
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('p', {
    staticClass: "text-bold mb-0"
  }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.csvInstructions')) + "\n                    ")])]), _c(VExpansionPanelContent, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.sampleCsvExplanationSeparator'))
    }
  })])], 1)], 1)], 1) : _vm._e()], 1), _c(VRow, [_vm.selectedBridge ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-0",
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('p', {
    staticClass: "text-bold mb-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.instructions')))])]), _c(VExpansionPanelContent, [_c(VCard, {
    staticClass: "elevation-0 v-card-text-area mdbox mt-6",
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.instructions
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.limitedDevices ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "margin-left": "5px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t(_vm.limitedDevices.translationKey, {
    n: _vm.remainingDevices
  })) + "\n                "), _c('br')])]) : _vm._e()], 1), _vm.selectedBridge ? _c(VBtn, {
    class: `v-btn-x mx-1 ml-2 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": _vm.downloadSampleCsv
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-download")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvDownload')) + "\n          ")], 1) : _vm._e(), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.selectedBridge || !_vm.parentId,
      "appendIcon": "fa-arrow-right"
    },
    on: {
      "click": function ($event) {
        _vm.step = 2;
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.continueBtn')) + "\n          ")])], 1), _c(VStepperContent, {
    attrs: {
      "step": "2"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.uploadYourFile')))]), _c(VRow, [_c(VCol, [_c('media-file-upload', {
    attrs: {
      "type": "file",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.csvUpload'),
      "buttonIcon": 'fal fa-file-csv'
    },
    on: {
      "file": _vm.uploadeFile
    }
  })], 1)], 1), _vm.contents.devices.length ? _c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.uploadIncludes', {
    n: _vm.contents.devices.length
  })) + "\n          ")]) : _vm._e(), _vm.validationErrors.length ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.errorsFound', {
    n: _vm.validationErrors.length
  })) + "\n          ")]) : _vm._e(), _vm.validationErrors.length ? _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": "20"
    }
  }, [_c(VDataTable, {
    attrs: {
      "items": _vm.validationErrors,
      "item-key": "id",
      "headers": [{
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.line'),
        sortable: false
      }, {
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.errorMessage'),
        sortable: false
      }]
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(items.item.lineNumber))]), _c('td', [_vm._v(_vm._s(items.item.reason))])])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n                ")])];
      },
      proxy: true
    }], null, false, 982889197)
  })], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    directives: [{
      name: "col",
      rawName: "v-col"
    }],
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.hasCsvUploaded || _vm.validationErrors.length > 0,
      "appendIcon": "fa-arrow-right"
    },
    on: {
      "click": function ($event) {
        _vm.step = 3;
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.continueBtn')) + "\n              ")])], 1)], 1)], 1), _c(VStepperContent, {
    attrs: {
      "step": "3"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.applyChanges')))]), _c(VTextField, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyChangesLabel')
    },
    model: {
      value: _vm.title,
      callback: function ($$v) {
        _vm.title = $$v;
      },
      expression: "title"
    }
  })], 1)], 1), _vm.hasUnsupportedImportColumn ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.unsupportedImportColumn')) + "\n              ")])])], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fal fa-file-alt",
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('span', {
    staticClass: "fontb pb-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.devicesTotal')) + ":")]), _vm._v("\n                       \n                      "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v(_vm._s(_vm.contents.devices.length))])])], 1), _c('core-virtualDevice-upload-list', {
    ref: "uploadList",
    attrs: {
      "tblHeaders": _vm.headers,
      "contents": _vm.contents.devices
    }
  })], 1)])], 1)], 1), _c('core-button', {
    attrs: {
      "disabled": _vm.hasUnsupportedImportColumn || !_vm.title || _vm.createButtonDisabled,
      "color": _vm.color,
      "appendIcon": "fa-check"
    },
    on: {
      "click": _vm.applyChanges
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkImport.create')) + "\n          ")])], 1)], 1)], 1)]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };